import { checkIsActiveTabSearchParamValid } from './checkIsActiveTabSearchParamValid'

export const getManagementSearchParams = () => {
  const queryString = window.location.search
  const searchParams = new URLSearchParams(queryString)

  const { activeTab, searchValue } = Object.fromEntries(searchParams)

  return {
    activeTab: checkIsActiveTabSearchParamValid(activeTab),
    searchValue: searchValue || '',
  }
}
